import { render, staticRenderFns } from "./Promo.vue?vue&type=template&id=13997db8&scoped=true"
import script from "./Promo.vue?vue&type=script&lang=js"
export * from "./Promo.vue?vue&type=script&lang=js"
import style1 from "./Promo.vue?vue&type=style&index=1&id=13997db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13997db8",
  null
  
)

export default component.exports